import { lazy, Suspense, useEffect } from 'react';

/// Components
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import {  Route, Routes, useLocation , useNavigate , useParams } from 'react-router-dom';
// action
import { checkAutoLogin } from 'shared/api/services/AuthService';
import { loginConfirmedAction, Logout } from 'store/legacyActionsBridge';
import { rememberPostLoginRedirect } from 'shared/utils/postLoginRedirect';
// import { isLogin } from 'shared/api/services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./css/style.css";
import "./css/event-overrides.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { NextStepModalHost } from "./shared/ui/NextStepModal";
import { MessageNotificationProvider } from "./context/MessageNotificationContext";
import SupportWidget from "./layout/SupportWidget";
// import Error404 from './jsx/pages/Error404';


const SignUp = lazy(() => import('./features/auth/pages/Registration'));
const LegalDocument = lazy(() => import('./features/legal/pages/legal-document'));
const PrivacyPolicyPage = lazy(() => import('./features/legal/pages/legal-document').then((mod) => ({ default: mod.PrivacyPolicyPage })));
const AccountDeletionPage = lazy(() => import('./features/legal/pages/legal-document').then((mod) => ({ default: mod.AccountDeletionPage })));
const Login = lazy(() => import('./features/auth/pages/Login'));
const ForgotPassword = lazy(() => import('./features/auth/pages/forgot-password'));
const VerifyEmail = lazy(() => import('./features/auth/pages/VerifyEmail'));
const ZiraatPayResultPage = lazy(() => import('./features/tickets/ziraatpay-result'));
const UserManualPage = lazy(() => import('./features/usermanual/pages/UserManualPage'));
const PublicBadgePage = lazy(() => import('./features/badge/PublicBadgePage'));
const DigitalCardPublic = lazy(() => import('./jsx/pages/DigitalCardPublic'));
const PublicTableListPage = lazy(() => import('./features/tables/public-table-list-page'));
const PublicTablePage = lazy(() => import('./features/tables/public-table-page'));

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
	
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}



function App (props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const isPublicBadgeRoute = location.pathname.startsWith('/badge/');
    const isPublicUserManualRoute = location.pathname.startsWith('/usermanual');

    useEffect(() => {
        const pathname = location.pathname;
        const isPublicDigitalCard = pathname.startsWith('/digital-card/');
        // Yaka karti QR'ini okutan ziyaretcinin hesabi olmayabilir; burasi
        // atlanmazsa checkAutoLogin onu login ekranina yonlendirir ve kart
        // hicbir zaman goruntulenemez.
        const isPublicBadge = pathname.startsWith('/badge/');
        const isPublicB2BTable = (pathname === '/b2b' || pathname.startsWith('/b2b/')) && !pathname.startsWith('/b2b/announcements');
        const isPublicAuthRoute =
            pathname === '/login' ||
            pathname === '/page-register' ||
            pathname === '/page-forgot-password' ||
            pathname === '/page-verify-email' ||
            pathname === '/ziraatpay-result' ||
            pathname.startsWith('/usermanual') ||
            pathname.startsWith('/legal/');
        if (isPublicDigitalCard || isPublicBadge || isPublicB2BTable || isPublicAuthRoute) {
            return;
        }
        checkAutoLogin(
            dispatch,
            navigate,
            {
                onLoginConfirmed: loginConfirmedAction,
                // Oturumsuz gelinen derin linki (ör. mail butonu) giris sonrasina sakla.
                onLogout: (nav) => {
                    rememberPostLoginRedirect(`${location.pathname}${location.search}`);
                    return Logout(nav);
                },
            },
        );
        // sadece mount'ta çalışsın; location.pathname burada kasıtlı olarak bağımlılıktan çıkarıldı
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, navigate]);

    // Badge links must bypass authenticated layouts and their protected API calls,
    // including when stale credentials remain in the browser.
    if (isPublicUserManualRoute || isPublicBadgeRoute) {
        return (
            <>
                <Suspense
                    fallback={
                        <div id="preloader">
                            <div className="sk-three-bounce">
                                <div className="sk-child sk-bounce1"></div>
                                <div className="sk-child sk-bounce2"></div>
                                <div className="sk-child sk-bounce3"></div>
                            </div>
                        </div>
                    }
                >
                    <Routes>
                        <Route path='/usermanual/*' element={<UserManualPage />} />
                        <Route path='/badge/:qrToken' element={<PublicBadgePage />} />
                        <Route path='/badge/:qrToken/download' element={<PublicBadgePage />} />
                    </Routes>
                    <ToastContainer position="top-right" autoClose={2500} newestOnTop />
                </Suspense>
                <SupportWidget publicView={isPublicBadgeRoute} />
            </>
        );
    }

    
    let routeblog = (         
      <Routes>   
        <Route  path='/login' element={<Login />} />
        <Route path='/page-register' element={<SignUp />} />        
        <Route path='/page-forgot-password' element={<ForgotPassword />} />
        <Route path='/page-verify-email' element={<VerifyEmail />} />
        <Route path='/ziraatpay-result' element={<ZiraatPayResultPage />} />
        <Route path='/b2b' element={<PublicTableListPage />} />
        <Route path='/b2b/:tableId' element={<PublicTablePage />} />
        <Route path='/digital-card/:cardId' element={<DigitalCardPublic />} />
        <Route path='/legal/privacy-policy' element={<PrivacyPolicyPage />} />
        <Route path='/legal/account-deletion' element={<AccountDeletionPage />} />
        <Route path='/legal/:document' element={<LegalDocument />} />
        <Route path='/*' element={<Index />} />
      </Routes> 
    );
    if (props.isAuthenticated) {
		return (
			  <>
            <Suspense fallback={
                <div id="preloader">
                    <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1"></div>
                        <div className="sk-child sk-bounce2"></div>
                        <div className="sk-child sk-bounce3"></div>
                    </div>
                </div>
              }
            >
              <MessageNotificationProvider>
                <Index />
              </MessageNotificationProvider>
              <ToastContainer position="top-right" autoClose={2500} newestOnTop />
              <NextStepModalHost />
            </Suspense>
            <SupportWidget />
        </>
      );
	}else{
		return (
			  <div className="vh-100">
            <Suspense fallback={
                <div id="preloader">
                    <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1"></div>
                        <div className="sk-child sk-bounce2"></div>
                        <div className="sk-child sk-bounce3"></div>
                    </div>
                </div>
              }
            >
                {routeblog}
                <ToastContainer position="top-right" autoClose={2500} newestOnTop />
            </Suspense>
            <SupportWidget />
			  </div>
		);
	}
};


const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

//export default connect((mapStateToProps)(App)); 
export default withRouter(connect(mapStateToProps)(App)); 
